import React from "react";
import Navbar from "./Navbar";
import Hero from "./Hero";
import Hr from "./Hr";
import Admin from "./Admin";
import Footer from "./Footer";

const Home = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <Hr />
      <Admin />
      <Footer />
    </>
  );
};

export default Home;
